<template>
  <section>
    <validation-observer ref="form">
      <div v-for="(product, index) in collection" :key="index">
        <hr v-if="index > 0" />
        <div :id="`top-widget-${index}`" class="flex rows top-widget">
          <!-- photo -->
          <div class="item photo simulator">
            <div
              v-if="collection.length > 1"
              @click="deleteProduct(index)"
              class="btn delete-btn secondary"
            >
              <i class="far fa-trash-alt"></i>
            </div>
            <div
              v-show="false"
              class="simulator-position"
              :class="{ onlyName: product.pet_name && !product.pet_phone }"
            >
              <div class="name-simulator">
                {{ product.pet_name && product.pet_name.toUpperCase() }}
              </div>
              <div class="phone-simulator">
                {{ product.pet_phone && product.pet_phone.toUpperCase() }}
              </div>
            </div>
            <img class="simulator-photo" :src="decodeImage(product.color)" />
          </div>
          <!-- data -->
          <div class="item">
            <div class="flex columns">
              <!-- informations -->
              <div class="item">
                <div class="flex columns">
                  <div class="item">
                    <h2>
                      Caminha
                      <span style="font-size: 37px; font-weight: 700">
                        NUVEM™
                      </span>
                    </h2>
                  </div>
                  <div class="item">
                    <h2 class="current-price">
                      <span
                        style="position:relative; color: #000; font-size: 24px; font-weight: 400"
                      >
                        <span
                          style=" position: absolute; border-bottom: 2px solid #000; width: 100%; top: 50%; left: -2px; "
                        ></span>
                        R$ {{ parseInt(product.price) * 2 }}
                      </span>
                      <span
                        style="color: #000; font-size: 24px; font-weight: 400"
                        >por</span
                      >
                      R$
                      {{ product.price }}
                    </h2>
                  </div>
                  <div class="item">
                    <h2 class="h2-subprice">
                      ou apenas <b>12x</b> de
                      <b>
                        <span class="current-price-parcela"
                          >R$ {{ product.price_parcel }}</span
                        ></b
                      >
                    </h2>
                  </div>
                </div>
              </div>
              <hr />

              <!-- color -->
              <div class="item">
                <div class="flex columns">
                  <div class="item">
                    <h3>
                      <span style="font-weight:400">Escolha a cor: </span
                      ><span id="current-color">{{
                        colorName(product.color)
                      }}</span>
                    </h3>
                  </div>
                  <div class="item">
                    <div class="flex wrap">
                      <div
                        v-for="(color, indexColor) in modelRender()"
                        :key="indexColor"
                      >
                        <div
                          :class="{
                            active: product.color == color,
                            'color-3742228_1': color == '3742228_1',
                            'color-3742228_2': color == '3742228_2',
                            'color-3742228_3': color == '3742228_3',
                            'color-3742228_4': color == '3742228_4',
                            'color-3742228_5': color == '3742228_5',
                            'color-3742228_6': color == '3742228_6',
                            'color-3742228_7': color == '3742228_7',
                            'color-3742228_8': color == '3742228_8',
                            'color-3742228_9': color == '3742228_9',
                            'color-3742228_10': color == '3742228_10',
                            'color-3742228_11': color == '3742228_11',
                            'color-3742228_12': color == '3742228_12',
                            'color-3742228_13': color == '3742228_13',
                            'color-3742228_14': color == '3742228_14',
                            'color-3742228_15': color == '3742228_15',
                          }"
                          class="item btn w-color"
                          style="margin-left: 5px;"
                          @click="product.color = color"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- size -->
              <div class="item">
                <div class="flex columns">
                  <div class="item">
                    <h3>
                      <span style="font-weight:400">Escolha o tamanho: </span>
                      <span id="current-size">{{ product.size }}</span>
                    </h3>
                  </div>
                  <div class="item" style="max-width: 400px">
                    <div class="flex wrap">
                      <div v-for="(size, indexSize) in sizes" :key="indexSize">
                        <div
                          :class="{
                            active: product.size == size,
                            'no-margin-left': indexSize == 0,
                          }"
                          class="item btn w-size"
                          @click="changeSizeProduct(index, size)"
                        >
                          {{ size }}
                          <small>12x R$ {{ getSizePrice(size) }}</small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="action">
        <div v-if="collection && collection.length < 2">
          <p style="text-align:center">
            <b>ATENÇÃO</b>: Ao comprar <b>2 únidades</b> ou mais você ganha

            <span style="font-size:18px"><b>10% de desconto</b></span
            >!!!
          </p>
          <p style="text-align:center">
            <small>*Oferta valida apenas para compras feitas HOJE.</small>
          </p>
        </div>
        <div v-else>
          <p style="text-align:center">
            Parabéns, você <b>ganhou 10 % de desconto</b>. Oferta valida apenas
            para compras feitas HOJE!
          </p>
        </div>

        <div class="btn secondary" @click="addNewProduct()">
          + Adicionar mais uma
        </div>

        <!-- button -->
        <div
          @click="buyProducts()"
          id="buy-link"
          style="text-decoration: none;color: #000;"
        >
          <div class="btn buy button-animate">Comprar Agora</div>
        </div>
      </div>

      <div v-if="loader" id="background-loader">
        <div class="loader" id="loader"></div>
        <p>Carregando...</p>
      </div>
    </validation-observer>
  </section>
</template>

<script>
import { mask } from "vue-the-mask";

const mapping_price = {
  "40cm": "169,90",
  "50cm": "209,90",
  "60cm": "239,90",
  "70cm": "269,90",
  "80cm": "309,90",
  "100cm": "389,90",
};

const mapping_parcel_price = {
  "40cm": "16,99",
  "50cm": "20,99",
  "60cm": "23,99",
  "70cm": "26,99",
  "80cm": "30,99",
  "100cm": "38,99",
};

const mapping_product_to_model = {
  "3742228_1": "Café Claro",
  "3742228_2": "Cinza Escuro",
  "3742228_3": "Rosa Claro",
  "3742228_4": "Branco",
  "3742228_5": "Cinza Claro",
  "3742228_6": "Damasco",
  "3742228_7": "Café",
  "3742228_8": "Verde Escuro",
  "3742228_9": "Vermelho Vinho",
  "3742228_10": "Rosa Pink",
  "3742228_11": "Roxo",
  // "3742228_12": "Verde Claro",
  // "3742228_13": "Nuvem Azul Claro",
  // "3742228_14": "Nuvem Azul Forte",
  "3742228_15": "Vermelho Claro",
};

const mapping_product = {
  "3742228_1 40cm": "R6JX9C9UGQ",
  "3742228_1 50cm": "Q10S5H8QAH",
  "3742228_1 60cm": "DL4DAJ324U",
  "3742228_1 70cm": "KIB2AI9LZA",
  "3742228_1 80cm": "RIKQ8JO7BR",
  "3742228_1 100cm": "AEGVF2HTJ1",

  "3742228_2 40cm": "FH96ZD4NAI",
  "3742228_2 50cm": "S2ZX2EDDP4",
  "3742228_2 60cm": "GEQV00WF15",
  "3742228_2 70cm": "JMNNPT9F5I",
  "3742228_2 80cm": "6Q26NNJZBW",
  "3742228_2 100cm": "O2D18MMFU5",

  "3742228_3 40cm": "KJ9V638JP3",
  "3742228_3 50cm": "65ASZGWF0K",
  "3742228_3 60cm": "258MPSFQLU",
  "3742228_3 70cm": "90Y3ZR0R1J",
  "3742228_3 80cm": "853JW7LJ7X",
  "3742228_3 100cm": "TF63SR50PM",

  "3742228_4 40cm": "LNAI01YWLR",
  "3742228_4 50cm": "7TMTF2GX2S",
  "3742228_4 60cm": "PLIWOF4P4S",
  "3742228_4 70cm": "G0DOZPRIAG",
  "3742228_4 80cm": "9DBR9ZYN63",
  "3742228_4 100cm": "5G90CDIBJY",

  "3742228_5 40cm": "KR6LHUOA4R",
  "3742228_5 50cm": "S1N7XAK9OO",
  "3742228_5 60cm": "TGF0980DB5",
  "3742228_5 70cm": "AAAQ0DXMDP",
  "3742228_5 80cm": "CPIEZOHDR1",
  "3742228_5 100cm": "H3YVIKY4Q3",

  "3742228_6 40cm": "3SWVWMK4KS",
  "3742228_6 50cm": "6BQN9N575W",
  "3742228_6 60cm": "9A7OD7SOTV",
  "3742228_6 70cm": "62NHP8C5XA",
  "3742228_6 80cm": "2VTKKZKDV4",
  "3742228_6 100cm": "7PUECHMW02",

  "3742228_7 40cm": "4KLJ10SI0U",
  "3742228_7 50cm": "21HBEOFDQK",
  "3742228_7 60cm": "SBZ5ELBN2V",
  "3742228_7 70cm": "60F7AS2G5V",
  "3742228_7 80cm": "TDJDLF5YU6",
  "3742228_7 100cm": "KDZAS0AASW",

  "3742228_8 40cm": "NKDBJ5JPPU",
  "3742228_8 50cm": "46SXSK9K3J",
  "3742228_8 60cm": "EHXMVU3WO2",
  "3742228_8 70cm": "R604Z0FF96",
  "3742228_8 80cm": "2NQDIW40B0",
  "3742228_8 100cm": "HYLG9NM5DS",

  "3742228_9 40cm": "E52UYKDGOT",
  "3742228_9 50cm": "CKCC67F9CH",
  "3742228_9 60cm": "HUN5IZGIPX",
  "3742228_9 70cm": "5S5N3BZFLY",
  "3742228_9 80cm": "EOFDDS9UW4",
  "3742228_9 100cm": "4EDRD2EOU5",

  "3742228_10 40cm": "ADP5URAX45",
  "3742228_10 50cm": "BYU5VRIZPU",
  "3742228_10 60cm": "7UMQ1ZXV4S",
  "3742228_10 70cm": "BKS2CVCDZV",
  "3742228_10 80cm": "B98MLBXH7M",
  "3742228_10 100cm": "JUBFPFKMXS",

  "3742228_11 40cm": "I0BLMJDRBP",
  "3742228_11 50cm": "9I6B3AMOV3",
  "3742228_11 60cm": "E75HQN05YC",
  "3742228_11 70cm": "749UM8ECI3",
  "3742228_11 80cm": "8D3AATG1O2",
  "3742228_11 100cm": "3TQ8T9NBER",

  "3742228_12 40cm": "K7FU6BRCLP",
  "3742228_12 50cm": "F5YAX3KCJZ",
  "3742228_12 60cm": "B6IKXB8BLL",
  "3742228_12 70cm": "OWG7RKUEVD",
  "3742228_12 80cm": "CNEANFMVDV",
  "3742228_12 100cm": "69TCMR711B",

  "3742228_13 40cm": "OQ7WTUZUAG",
  "3742228_13 50cm": "217JPKKYKO",
  "3742228_13 60cm": "SQH36DSH03",
  "3742228_13 70cm": "8884WMD6A4",
  "3742228_13 80cm": "C63KVEOB5P",
  "3742228_13 100cm": "2IN652DO35",

  "3742228_14 40cm": "JQARB4W8HI",
  "3742228_14 50cm": "DP3ZZ4J4PH",
  "3742228_14 60cm": "NDVMF280BD",
  "3742228_14 70cm": "I1W2IGP1FZ",
  "3742228_14 80cm": "TTB04DX03C",
  "3742228_14 100cm": "K60AYJ20QS",

  "3742228_15 40cm": "24RDU1P85O",
  "3742228_15 50cm": "6B42NW4LR0",
  "3742228_15 60cm": "MX5PQQL7XV",
  "3742228_15 70cm": "O2802DT3VJ",
  "3742228_15 80cm": "OOXZND4R8M",
  "3742228_15 100cm": "KRV75DBJ8X",
};

import Model3742228_1 from "@/assets/imgs/light-coffee.png";
import Model3742228_2 from "@/assets/imgs/gray.png";
import Model3742228_3 from "@/assets/imgs/pink.png";
import Model3742228_4 from "@/assets/imgs/white.png";
import Model3742228_5 from "@/assets/imgs/light-grey.png";
import Model3742228_6 from "@/assets/imgs/apricot.png";
import Model3742228_7 from "@/assets/imgs/coffee.png";
import Model3742228_8 from "@/assets/imgs/dark-green.png";
import Model3742228_9 from "@/assets/imgs/red-wine.png";
import Model3742228_10 from "@/assets/imgs/pink2.png";
import Model3742228_11 from "@/assets/imgs/purple.png";
import Model3742228_12 from "@/assets/imgs/light-green.png"; // meio diferente da cor do produto
import Model3742228_13 from "@/assets/imgs/rainbow-blue.png"; // sem foto do produto correta
import Model3742228_14 from "@/assets/imgs/rainbow-blue.png"; // sem foto do produto correta
import Model3742228_15 from "@/assets/imgs/pink3.png"; //

const imagesColor = {
  "3742228_2": Model3742228_2,
  "3742228_3": Model3742228_3,
  "3742228_1": Model3742228_1,
  "3742228_4": Model3742228_4,
  "3742228_5": Model3742228_5,
  "3742228_6": Model3742228_6,
  "3742228_7": Model3742228_7,
  "3742228_8": Model3742228_8,
  "3742228_9": Model3742228_9,
  "3742228_10": Model3742228_10,
  "3742228_11": Model3742228_11,
  "3742228_12": Model3742228_12,
  "3742228_13": Model3742228_13,
  "3742228_14": Model3742228_14,
  "3742228_15": Model3742228_15,
};

const emptyProduct = {
  price: "169,90",
  price_parcel: "16,99",
  color: "3742228_2",
  size: "40cm",
};

export default {
  directives: { mask },
  name: "simulator",
  data() {
    return {
      loader: false,
      collection: [Object.assign({}, emptyProduct)],
      colors: Object.values(mapping_product_to_model),
      sizes: ["40cm", "50cm", "60cm", "70cm", "80cm", "100cm"],
    };
  },
  computed: {},
  mounted() {},
  methods: {
    getSizePrice(size) {
      // return mapping_price[size];
      return mapping_parcel_price[size];
    },
    modelRender() {
      let result = [];

      let aux = Object.keys(mapping_product_to_model);

      aux.forEach((k) => {
        result.push(mapping_product_to_model[k]);
      });

      return aux;
    },
    colorName(productId) {
      return mapping_product_to_model && mapping_product_to_model[productId];
    },
    addNewProduct() {
      this.collection.push(Object.assign({}, emptyProduct));
    },
    deleteProduct(index) {
      if (window.confirm("Você realmente quer remover o produto?")) {
        this.collection.splice(index, 1);
      }
    },
    buyProducts() {
      // save cookie product :)
      this.$refs.form.validate().then((success) => {
        if (!success) {
          alert("Você precisa preencher o Nome do PET");
          return;
        }

        let saveInfoProducts = [];

        this.collection.forEach((p) => {
          saveInfoProducts.push({
            color: p.color,
            size: p.size,
          });
        });

        // generate url
        let productsCode = [];
        this.collection.forEach((p) => {
          // get code checkout
          let key = `${p.color} ${p.size}`;
          let productCode = mapping_product[key];

          productsCode.push(`${productCode}:1`);
        });

        let url = `https://seguro.compresoagora.com/r/${productsCode.join(
          ","
        )}`;

        // 10% off in buy 2 products
        if (this.collection && this.collection.length > 1) {
          url += "?promocode=10%OFF";
        }

        this.loader = true;

        // redirect
        window.top.location.href = url;
      });
    },
    decodeImage(color) {
      return imagesColor[color];
    },
    changeSizeProduct(index, size) {
      this.collection[index].size = size;

      this.collection[index].price = mapping_price[size];
      this.collection[index].price_parcel = mapping_parcel_price[size];
    },
    setCookie(name, value) {
      const date = new Date();
      const days = 30;
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      const expires = "; expires=" + date.toGMTString();
      document.cookie =
        name + "=" + value + expires + "; path=/;domain=compresoagora.com";
      // document.cookie = name + "=" + value + expires + "; path=/";
    },
  },
};
</script>

<style lang="scss" scoped>
body {
  background-color: #ffffff;
}
.flex {
  display: flex !important;
}
.wrap {
  flex-flow: wrap;
}
h2 {
  margin-top: 5px;
  margin-bottom: 5px;
}
.center {
  align-items: center;
  align-content: center;
  justify-content: center;
}
.columns {
  flex-direction: column;
}
.rows {
  flex-direction: row;
}
.item {
  flex: 1;
}
.photo > img {
  height: 700px;
}
.delete-btn {
  width: 10px;
  padding: 20px;
  position: absolute;
  z-index: 1001;
  right: 20px;
}
.btn {
  padding-top: 15px;
  padding-bottom: 15px;
  border-radius: 5px;
  background-color: #e6e5e5;
  border-bottom: 3px solid rgb(0, 0, 0);
  font-weight: 700;
  cursor: pointer;
}

.w-color {
  padding: 15px;
  border-radius: 5px;
  background-color: #c2c2c2;
  margin-left: 10px;
  border-bottom: 3px solid rgb(0, 0, 0);
  border-left: 1px solid rgb(0, 0, 0);
  font-weight: 700;
  cursor: pointer;
  &.active {
    border-bottom: 0px solid #333;
    border-left: 0px solid #333;
    filter: grayscale(30%);
  }
}
.secondary {
  margin-top: 15px;
  padding-top: 25px;
  padding-bottom: 25px;
  color: #0ab26e;
  background: #fff;
  border: 3px solid #0ab26e;
  text-align: center;
  box-shadow: 2px 3px 2px #8a8a8a;
  &:hover {
    background: #0ab26e;
    color: #fff;
  }
}

.w-size {
  padding: 15px;
  border-radius: 5px;
  background-color: #c2c2c2;
  margin-left: 15px;
  border-bottom: 3px solid rgb(0, 0, 0);
  border-left: 1px solid rgb(0, 0, 0);
  font-weight: 700;
  font-size: 14px;
  margin-top: 15px;
  display: inline-grid;
  text-align: center;
  cursor: pointer;

  small {
    font-size: 10px;
    margin-top: 10px;
  }

  &.active {
    /* border: 1px solid #333; */
    border-bottom: 0px solid #333;
    border-left: 0px solid #333;
    background-color: #0ab26e;
  }
}

.buy {
  margin-top: 15px;
  margin-left: 0px;
  background-color: #c3c3c3;
  color: #fff;
  background-color: #0ab26e;
  text-align: center;
  font-size: 18px;
  font-weight: 800;
  padding-top: 25px;
  padding-bottom: 25px;
  border-radius: 5px;
  width: 100%;
}

hr {
  height: 0px;
  width: 100%;
  border-bottom: 1px solid rgba(51, 51, 51, 0.996);
}

.item input {
  width: 97%;
  height: 40px;
  font-size: 21px;
}
.simulator {
  position: relative;
  max-width: 700px;
}

.name-simulator {
  color: #fff;
  font-size: 32px;
  font-weight: 700;
  min-height: 55px;
  font-family: Muli, sans-serif;
  font-style: normal;
}
.phone-simulator {
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  font-family: Muli, sans-serif;
  font-style: normal;
}
.simulator-position {
  position: absolute;
  text-align: center;
  z-index: 10;
  top: -9%;
  left: -25%;
  width: 100%;
  height: 100%;
  padding-top: 50%;
  transform: rotate(19deg);
  &.onlyName {
    top: -8%;
    left: -26%;
    .name-simulator {
      font-size: 50px !important;
    }
  }
}
.top-widget {
  max-width: 1366px;
  margin: 0 auto;
  margin-bottom: 35px;
}

.color-3742228_1 {
  background: url("../../assets/imgs/color/light-coffee.jpg");
}

.color-3742228_2 {
  background: url("../../assets/imgs/color/gray.jpg");
}

.color-3742228_3 {
  background: url("../../assets/imgs/color/pink.jpg");
}

.color-3742228_4 {
  background: url("../../assets/imgs/color/white.jpg");
}

.color-3742228_5 {
  background: url("../../assets/imgs/color/light-grey.jpg");
}

.color-3742228_6 {
  background: url("../../assets/imgs/color/apricot.jpg");
}

.color-3742228_7 {
  background: url("../../assets/imgs/color/coffee.jpg");
}

.color-3742228_8 {
  background: url("../../assets/imgs/color/dark-green.jpg");
}

.color-3742228_9 {
  background: url("../../assets/imgs/color/red-wine.jpg");
}

.color-3742228_10 {
  background: url("../../assets/imgs/color/pink2.jpg");
}

.color-3742228_11 {
  background: url("../../assets/imgs/color/purple.jpg");
}

.color-3742228_12 {
  background: url("../../assets/imgs/color/light-green.jpg");
}

.color-3742228_13 {
  background: url("../../assets/imgs/color/rainbow-blue.jpg");
}

.color-3742228_14 {
  background: url("../../assets/imgs/color/rainbow-blue.jpg");
}

.color-3742228_15 {
  background: url("../../assets/imgs/color/pink3.jpg");
}

@keyframes zoominoutsinglefeatured {
  0% {
    transform: scale(1, 1);
  }
  50% {
    transform: scale(1.1, 1.1);
  }
  100% {
    transform: scale(1, 1);
  }
}
.button-animate {
  animation: zoominoutsinglefeatured 1s infinite;
}

.loader {
  border: 16px solid #f3f3f3; /* Light grey */
  border-top: 16px solid #3498db; /* Blue */
  border-radius: 50%;
  width: 120px;
  height: 120px;
  animation: spin 2s linear infinite;
}

.h2-subprice {
  font-weight: 400;
  font-size: 16px;
}
.current-price {
  color: #000;
  // color: #7154ff;
  font-size: 26px;
}

.current-price-parcela {
  font-size: 36px;
  color: #0ab26e;
  // color: #3107ff;
}

#background-loader {
  position: fixed;
  display: flex !important;
  flex-direction: column;
  color: #fff;
  font-weight: 700;
  align-content: center;
  align-items: center;
  align-self: center;
  justify-content: center;
  z-index: 1000;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.hide-loader {
  display: none;
}

.group-input {
  &.errors input {
    border: 1px solid red;
    border-radius: 4px;
  }
  .erros-alert {
    display: inline-block;
    color: red;
    font-size: 11px;
  }
}

@media screen and (max-width: 1280px) {
  h2 {
    font-size: 18px;
  }
  .rows {
    flex-direction: column;
  }
  .photo > img {
    width: 100%;
    height: auto;
  }
  .item input {
    width: 95%;
  }
  .w-color {
    margin-left: 5px;
  }
  .w-size {
    font-size: 20px;
    margin-left: 5px;
  }
  .name-simulator {
    color: #fff;
    font-size: 18px;
    font-weight: 700;
    min-height: 26px;
    font-family: Muli, sans-serif;
    font-style: normal;
  }
  .phone-simulator {
    color: #fff;
    font-size: 8px;
    font-family: Muli, sans-serif;
    font-style: normal;
  }
  .add {
    margin-top: 15px;
    padding-top: 25px;
    padding-bottom: 25px;
  }
  .btn {
    padding: 35px;
    margin-top: 5px;
    text-align: center;
  }
  .delete-btn {
    position: absolute;
    z-index: 999;
    width: auto;
    font-size: 20px;
    padding: 20px;
    position: absolute;
    right: 10px !important;
  }

  .secondary {
    margin-top: 15px;
  }
  .buy {
    width: 100%;
    padding-left: 0px;
    padding-right: 0px;
    padding-top: 35px;
    padding-bottom: 35px;
    margin-left: 0px;
    margin-top: 30px;
    text-align: center;
  }

  .simulator-position {
    height: 25%;
    top: -20px;
    left: -50px;

    &.onlyName {
      top: -20px;
      left: -50px;
      .name-simulator {
        font-size: 28px !important;
      }
    }
  }
}
</style>
